import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const PageContent = styled.div`
  opacity: 1;
  animation: fadeIn 2s ease;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;

const PageTitle = styled.h1`
  opacity: 1;
  animation: fromLeft 2s ease;

  @keyframes fromLeft {
    0% {
      opacity 0;
      transform: translateX(-50px);
    }

    100% {
      opacity: 1;
      transform: translateX(0px);
    }
  }
`;

export default ({ pageContext, data }) => {
  const categorisedMedia = data.allWordpressWpMedia.edges;
  return (
    <Layout categorisedMedia={categorisedMedia}>
      <SEO pageTitle={pageContext.title} pageSlug={pageContext.slug}/>
      <PageTitle dangerouslySetInnerHTML={{ __html: pageContext.title }} />
      <PageContent dangerouslySetInnerHTML={{ __html: pageContext.content }} />
    </Layout>
  );
};

export const query = graphql`
  query MediaByCategory($categoryNames: [String]!) {
    allWordpressWpMedia(
      filter: { categories: { elemMatch: { name: { in: $categoryNames } } } }
    ) {
      edges {
        node {
          source_url
          caption
          categories {
            name
          }
          media_details {
            height
            width
          }
          title
          description
          wordpress_id
        }
      }
    }
  }
`;
